<div class="p-4 sm:p-v-spacing card mb-2.5 rounded-md bg-light shadow-md">
  <div class="flex flex-row mb-2">
    <input type="checkbox" class="h-5 sm:h-6 w-5 sm:w-6 min-w-[20px] sm:min-w-[24px] mr-3 cursor-pointer text-visBtn-tertiary" [checked]="data.selected" (click)="onCheckboxChange(data)" [value]="data.selected">
    <div class="flex-1 mr-3 min-w-0">
      <span class="bundle-card__title font-bold text-base md:text-baselg">{{productTitle}}</span>
      @if (showHours && data.productData?.productHours) {
        <p class="bundle-card__hours text-sm text-vis-subtle font-bold">{{data.productData.productHours}} Hrs</p>
      }
    </div>
    @if (data.multipleRegulators) {
      <button
        type="button"
        class="text fa-1x mr-2 text-vis-star bg-transparent border-0 p-0 cursor-pointer inline-flex items-start mt-1 justify-center"
        aria-label="View multiple regulator warning"
        (click)="activateModal()"
      >
        <fa-icon [icon]="warnIcon"></fa-icon>
      </button>
    }
    <span class="bundle-card__price font-extrabold flex items-start text-base md:text-baselg min-w-0" [innerHTML]="currentPrice"></span>
    @if (productDescription.length > 0) {
      <button
        type="button"
        class="text fa-1x text-vis-subtle ml-2 cursor-pointer bg-transparent border-0 p-0 inline-flex items-start mt-1 justify-center"
        [attr.aria-expanded]="showDescriptionAccordion"
        aria-controls="course-description-panel"
        [attr.aria-label]="showDescriptionAccordion ? 'Hide course description' : 'Show course description'"
        (click)="showDescriptionAccordion = !showDescriptionAccordion"
      >
        <fa-icon [icon]="showDescriptionAccordion ? openCaretIcon : caretIcon"></fa-icon>
      </button>
    }
  </div>
  <div class="flex flex-row items-center justify-start pl-8 text-xs md:text-base font-bold text-vis-subtle">
    @if (!data.hidePills) {
      <span class="border rounded-[100px] border-ace-grey-500 px-2 py-.5 ml-2">{{deliveryMethod}}</span>
      <span class="border rounded-[100px] border-ace-grey-500 px-2 py-.5 ml-2">{{requireLabel}}</span>
    }
    @if (data.section === 'base' && data.webinarData?.length > 0 && !hideScheduleCta) {
      <span (click)="showWebinarSchedule($event, data.webinarData)" class="tertiary-button !text-xs md:!text-base ml-2">{{viewScheduleLabel}}</span>
    }
  </div>
  @if (showDescriptionAccordion) {
    <div id="course-description-panel" role="region" aria-label="Course description" class="mt-3 pl-8">
      <hr class="border-ace-grey-300 mb-3">
      <p class="text-sm text-vis-subtle">{{productDescription}}</p>
    </div>
  }
</div>
